import script from "./SunrisePageHero.vue?vue&type=script&lang=ts&setup=true"
export * from "./SunrisePageHero.vue?vue&type=script&lang=ts&setup=true"

import "./SunrisePageHero.vue?vue&type=style&index=0&id=59498f10&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59498f10"]])

export default __exports__